import { CommonModule } from "@angular/common";
import { Component, Input, signal } from "@angular/core";

@Component({
  selector: "rs-json-viewer",
  templateUrl: "./json-viewer.component.html",
  styleUrl: "./json-viewer.component.css",
  imports: [CommonModule],
  standalone: true
})
export class JsonViewerComponent {
  @Input() json: any;
  @Input() expanded?: boolean;
  @Input() collapsedLabel = "{...}";
  expandedMap = signal(new Map<string, boolean>());

  private expandAllKeys(obj: any, path: string[] = []): void {
    if (obj && typeof obj === "object") {
      const currentMap = this.expandedMap();

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          const itemPath = path.concat([String(index)]);
          currentMap.set(this.pathKey(itemPath), true);
          this.expandAllKeys(item, itemPath);
        });
      } else {
        Object.keys(obj).forEach((key) => {
          const keyPath = path.concat([key]);
          currentMap.set(this.pathKey(keyPath), true);
          this.expandAllKeys(obj[key], keyPath);
        });
      }

      this.expandedMap.set(currentMap);
    }
  }

  isExpandable(value: any): boolean {
    return value && typeof value === "object";
  }

  toggle(path: string[]): void {
    const current = this.expandedMap();
    const newMap = new Map(current);
    const defaultExpanded = this.expanded ?? false;
    const key = this.pathKey(path);
    newMap.set(key, !(newMap.get(key) ?? defaultExpanded));
    this.expandedMap.set(newMap);
  }

  isExpanded(path: string[]): boolean {
    return this.expandedMap().get(this.pathKey(path)) ?? this.expanded ?? false;
  }

  keys(obj: any): string[] {
    return Object.keys(obj);
  }
  beArray(obj: any) {
    return Array.isArray(obj);
  }

  private pathKey(path: string[]): string {
    return JSON.stringify(path);
  }
}
